import { DataSelectionDialogDataModel } from '~components/dialogs/data-selection-dialog/models/data-selection-dialog-data.model';
import { BaseSearchStore } from '~core/abstractions/base-search.store';
import { Identifyable } from '~core/abstractions/identifyable';
import { ColumnFilterModel } from '~core/models/column-filter.model';
import { ColumnSortModel } from '~core/models/column-sort.model';

export class QuickSearchConfigModel<TList extends Identifyable<TId>, TId = number> {
    store!: BaseSearchStore<TList, TId>;
    labelDisplayFn!: (data?: TList) => string;
    topLabelDisplayFn?: (data?: TList) => string;
    shouldHideDataSelectDialogButton?: boolean;
    dataSelectionDialogConfig?: DataSelectionDialogDataModel<TList, TId>;
    sortings?: ColumnSortModel[] = [];
    filters?: ColumnFilterModel[] = [];

    constructor(init: QuickSearchConfigModel<TList, TId>) {
        Object.assign(this, init);
    }
}
